
  import { defineComponent } from 'vue'
  import Player from '@/player/Player.vue'

  export default defineComponent({
    components: {
      Player,
    },
  })
